import { useEffect, useRef, useState } from 'react'
import { MediaSizes } from '@/features/media/types'
import {
  type MediaImageParams,
  useMediaImage,
} from '@/features/media/useMediaImage'

type Props = MediaImageParams
export const CardImage = (props: Props) => {
  const { mediaType, mediaCode, fileAttachments } = props
  const ref = useRef(null)
  const [shouldFetch, setShouldFetch] = useState(false)

  const { url } = useMediaImage(
    { mediaType, mediaCode, fileAttachments },
    MediaSizes.Small,
    shouldFetch,
  )

  useEffect(() => {
    const onChange: IntersectionObserverCallback = (entries) => {
      if (entries.some((e) => e.isIntersecting)) {
        setShouldFetch(true)
      } else {
        setShouldFetch(false)
      }
    }
    const observer = new window.IntersectionObserver(onChange)

    if (ref.current) observer.observe(ref.current)

    return () => {
      observer.disconnect()
    }
  }, [])

  return (
    <img
      ref={ref}
      style={{ width: '100%', height: '10rem', objectFit: 'contain' }}
      src={url}
    />
  )
}
